/**
 * Safely converts a string to an enum value, returning a default if invalid
 */
export function toEnumWithDefault<T extends { [key: string]: string }>(
    enumObj: T,
    value: unknown,
    defaultValue: T[keyof T],
): T[keyof T] {
    if (Object.values(enumObj).includes(value as T[keyof T])) {
        return value as T[keyof T];
    }
    return defaultValue;
}
